import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";

/**
 * A new tile, with its parent, its content and its place on the grid.
 *
 * `target` is the raw link-target JSON as a STRING, deliberately not an object:
 * the column it lands in is a text column the backend never decodes, which is
 * what lets a target kind this version does not recognise survive a round trip
 * unchanged.
 *
 * `imageAssetUid` is the asset uid in transport (ShortId) spelling, exactly as
 * the upload response returned it. Nothing on its path converts it.
 */
export interface CreateLinkTilePayload {
    readonly uid: string;
    readonly linkviewUid: string;
    readonly text: string;
    readonly color?: string;
    readonly icon?: string;
    readonly target?: string;
    readonly imageAssetUid?: string;
    readonly x: number;
    readonly y: number;
    readonly w: number;
    readonly h: number;
}

/**
 * Sent inside the save bulk, BEFORE the updates, the deletes and the trailing
 * reorder — the reorder names every tile that exists after the save, so a
 * create must already have run for its uid to resolve there.
 */
export class CreateLinkTileCommand extends AbstractCommand<CreateLinkTilePayload> {

    public name = CommandName.CREATE_LINK_TILE;

    public tags: string[] = [`entity`, `create`, `link-tile`];

    constructor(payload: CreateLinkTilePayload) {
        super('link-tile', payload.uid, payload);
    }
}
